module.exports = __webpack_public_path__ + "6274da9edcaa39ecbb57395ebd6b5a79.png";


/*****************
 ** WEBPACK FOOTER
 ** ./blog/building-a-graphql-server-with-node-js-and-sql/GraphQL_NodeJS.png
 ** module id = 336
 ** module chunks = 0
 **/